import UXCoreModalHeader from './UXCoreModalHeader';

export default UXCoreModalHeader;
